<template>
  <section class="pricing-page">
    <div class="pricing-content">
      <div class="pricing-heading">
        <h3 class="pricing-heading__title">보안 솔루션 가격 안내</h3>
        <p class="pricing-heading__desc">
          제품별 월 구독 요금과 구축형 제품 정보를 확인해보세요.
        </p>
      </div>

      <p class="pricing-notice">
        ※ 상기 금액은 VAT 미포함 기준이며, 실제 정책에 따라 달라질 수 있습니다.
      </p>

      <div class="pricing-section">
        <div class="pricing-grid">
          <div
            v-for="item in filteredProducts"
            :key="item.id"
            class="product-card"
          >
            <div v-if="item.isBest" class="product-badge">베스트</div>

            <h3 class="product-title">
            {{ item.name }}
            <span v-if="item.subtitle" class="product-title__sub">{{ item.subtitle }}</span>
          </h3>

            <!-- <div class="product-image-wrap">
              <img class="product-image" :src="item.image" :alt="item.name" />
            </div> -->

            <p class="product-desc">{{ item.description }}</p>

            <div class="product-feature-section">
              <div class="product-feature-title">제품 특징</div>
              <ul class="product-feature-list">
                <li
                  v-for="(feature, index) in item.features"
                  :key="index"
                  class="product-feature-item"
                >
                  {{ feature }}
                </li>
              </ul>
            </div>

            <div class="product-price">
              <div v-if="item.onPremise" class="product-price__row">
                <span>구축형 제품</span>
                <strong>별도 문의</strong>
              </div>

              <div v-if="item.monthlyPrice" class="product-price__row">
                <span>월 구독</span>
                <strong>{{ formatPrice(item.monthlyPrice) }}</strong>
              </div>

              <div v-if="item.yearlyPrice" class="product-price__row">
                <span>1년 구독</span>
                <strong>{{ formatPrice(item.yearlyPrice) }}</strong>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="pricing-contact">
        <div class="pricing-contact__header">
          <h4 class="pricing-contact__title">도입 및 견적 문의</h4>
          <p class="pricing-contact__desc">
            구축형 제품 및 상세 견적이 필요하신 경우 아래 연락처로 문의해 주세요.
          </p>
        </div>

        <div class="pricing-contact__box">
          <!-- <div class="pricing-contact__item">
            <span class="pricing-contact__label">대표번호</span>
            <strong class="pricing-contact__value">{{ contact.tel }}</strong>
          </div>

          <div class="pricing-contact__item">
            <span class="pricing-contact__label">팩스</span>
            <strong class="pricing-contact__value">{{ contact.fax }}</strong>
          </div> -->

          <div class="pricing-contact__item">
            <span class="pricing-contact__label">담당 부서</span>
            <strong class="pricing-contact__value">{{ contact.department }}</strong>
          </div>

          <div class="pricing-contact__item">
            <span class="pricing-contact__label">담당자</span>
            <strong class="pricing-contact__value">{{ contact.managerName }}</strong>
          </div>

          <div class="pricing-contact__item">
            <span class="pricing-contact__label">담당자 연락처</span>
            <strong class="pricing-contact__value">{{ contact.managerTel }}</strong>
          </div>

          <div class="pricing-contact__item">
            <span class="pricing-contact__label">이메일</span>
            <a class="pricing-contact__link">
              {{ contact.email }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ProductPricingSection',
  data() {
    return {
      selectedCategory: 'all',
      openFeatureId: null,
      products: [
        {
          id: 1,
          name: '보안 솔루션 UWSS',
          // subtitle: 'WEBCastle + WSFinder + WMDS',
          subtitle: '웹 보안 통합 운영 솔루션',
          // description: '웹 보안 통합 운영 솔루션',
          image: '/images/products/uwss.png',
          monthlyPrice: 500000,
          yearlyPrice: null,
          isBest: false,
          onPremise: true,
          category: 'security',
          featureLink: '/products/uwss',
          features: [
            '통합 보안 관리',
            '제품별 연계 운영',
            '관제 효율 향상',
            '웹 보안 운영 지원',
          ],
        },
        {
          id: 2,
          name: 'WEBCastle',
          // subtitle: 'Web Application Firewall',
          subtitle: '웹 공격 탐지 및 차단 솔루션',
          // description: '웹 공격 탐지 및 차단 솔루션',
          image: '/images/products/webcastle.png',
          monthlyPrice: 250000,
          yearlyPrice: null,
          isBest: false,
          onPremise: true,
          category: 'web',
          featureLink: '/products/webcastle',
          features: [
            '보안관제 및 통합관리',
            '접속보안관리',
            '보안정책 설정',
            'SSL 환경 탐지·방어',
          ],
        },
        {
          id: 3,
          name: 'WSFinder',
          // subtitle: 'Web Shell Detection',
          subtitle: '웹쉘·악성 URL 탐지 및 원격 관리 솔루션',
          // description: '웹쉘·악성 URL 탐지 및 원격 관리 솔루션',
          image: '/images/products/wsfinder.png',
          monthlyPrice: 250000,
          yearlyPrice: null,
          isBest: false,
          onPremise: true,
          category: 'web',
          featureLink: '/products/wsfinder',
          features: [
            '웹쉘·악성 URL 탐지',
            '원격 점검 지원',
            '격리·복원·예외 처리',
            '통계 보고서 제공',
          ],
        },
        {
          id: 4,
          name: 'WMDS',
          // subtitle: 'Web Malware Detection',
          subtitle: '악성코드 유포 사이트 탐지 및 분석 솔루션',
          // description: '악성코드 유포 사이트 탐지 및 분석 솔루션',
          image: '/images/products/wmds.png',
          monthlyPrice: 250000,
          yearlyPrice: null,
          isBest: false,
          onPremise: true,
          category: 'data',
          featureLink: '/products/wmds',
          features: [
            '외부링크 추적',
            '최신 DB 패턴 적용',
            '난독화 처리',
            '간편한 등록',
          ],
        },
      ],
      contact: {
        // tel: '+82 070-4640-3030',
        // fax: '82-02-6944-8448',
        department: '영업부',
        managerName: '설진욱',
        managerTel: '010-5688-1824',
        email: 'sales@f1security.co.kr',
      },
    };
  },
  computed: {
    filteredProducts() {
      if (this.selectedCategory === 'all') {
        return this.products;
      }

      return this.products.filter(item => item.category === this.selectedCategory);
    },
  },
  methods: {
    selectCategory(category) {
      this.selectedCategory = category;
    },
    formatPrice(price) {
      if (price === null || price === undefined) {
        return '별도 문의';
      }

      return `${price.toLocaleString()} 원`;
    },
    toggleFeature(id) {
      this.openFeatureId = this.openFeatureId === id ? null : id;
    },
  },
};
</script>

<style scoped>
.pricing-page {
  padding: 0 48px;
}

.pricing-content {
  min-width: 0;
}

.pricing-heading {
  margin-top: 40px;
  margin-bottom: 24px;
  text-align: center;
}

.pricing-heading__title {
  margin: 0 0 12px;
  font-size: 52px;
  font-weight: 800;
  line-height: 1.25;
  color: #111;
}

.pricing-heading__desc {
  margin: 0;
  font-size: 18px;
  color: #667085;
}

.pricing-notice {
  margin-top: 28px;
  color: #7a8494;
  font-size: 14px;
  line-height: 1.6;
  text-align: right;
}

.pricing-section {
  padding: 56px 48px;
  margin-bottom: 40px;
  border-radius: 40px;
  background: #f3f5f8;
}

.pricing-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 24px;
}

.product-card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 600px;
  padding: 34px 28px 36px;
  border-radius: 36px;
  background: #fff;
  border: 2px solid transparent;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  overflow: visible;
}

.product-card:hover,
.product-card--active {
  border-color: #a8c0ff;
  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.13);
}

.product-badge {
  position: absolute;
  top: 24px;
  right: 22px;
  padding: 8px 14px;
  border-radius: 999px;
  background: #ffd93d;
  color: #6d5200;
  font-size: 15px;
  font-weight: 800;
}

.product-title {
  min-height: 88px;
  margin: 54px 0 6px;
  color: #111;
  font-size: 28px;
  font-weight: 800;
  line-height: 1.35;
  text-align: center;
  word-break: keep-all;
}

.product-title__sub {
  display: block;
  margin-top: 6px;
  font-size: 16px;
  font-weight: 600;
  color: #667085;
}

.product-image-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 230px;
  margin-bottom: 24px;
  border-radius: 20px;
  background: #f8f8f8;
}

.product-image {
  max-width: 220px;
  max-height: 180px;
  object-fit: contain;
}

.product-desc {
  min-height: 0;
  margin-bottom: 8px;
  color: #444;
  font-size: 17px;
  line-height: 1.6;
  text-align: center;
  word-break: keep-all;
}

.product-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin: 0 auto 44px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #2f6bff;
  font-size: 18px;
  font-weight: 700;
  cursor: pointer;
}

.product-link__arrow {
  font-size: 16px;
  line-height: 1;
  transition: transform 0.18s ease;
}

.product-feature-wrap:hover .product-link__arrow {
  transform: rotate(180deg);
}

.product-feature-wrap {
  position: relative;
  display: flex;
  justify-content: center;
  margin: 0 auto 20px;
}

.product-feature-pop {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 20;
  width: 200px;
  padding: 20px 18px 16px;
  margin-bottom: -10px;
  padding-bottom: 26px;
  border-radius: 20px;
  background: #fff;
  box-shadow: 0 10px 36px rgba(15, 23, 42, 0.18);
  text-align: center;
  cursor: default;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.18s ease, transform 0.18s ease;
  pointer-events: none;
}

.product-feature-wrap:hover .product-feature-pop {
  opacity: 1;
  visibility: visible;
  transform: translateX(-50%) translateY(0);
  pointer-events: auto;
}

.product-feature-pop__title {
  display: inline-block;
  margin-bottom: 24px;
  padding-bottom: 10px;
  border-bottom: 4px solid #2f6bff;
  color: #2f6bff;
  font-size: 20px;
  font-weight: 800;
  line-height: 1.2;
}

.product-feature-chip-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
}

.product-feature-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 56px;
  padding: 0 26px;
  border-radius: 999px;
  background: #f2f4f7;
  color: #3d4754;
  font-size: 17px;
  font-weight: 800;
  line-height: 1.2;
  word-break: keep-all;
  text-align: center;
  transition: transform 0.15s ease, background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;
}

.product-feature-chip:hover {
  transform: scale(1.06);
  background: #2f6bff;
  color: #fff;
  box-shadow: 0 6px 18px rgba(47, 107, 255, 0.3);
}

.product-feature-section {
  margin-bottom: 4px;
}

.product-feature-title {
  margin-bottom: 12px;
  color: #2f6bff;
  font-size: 15px;
  font-weight: 700;
}

.product-feature-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.product-feature-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border-radius: 12px;
  background: #f3f5f8;
  color: #3d4754;
  font-size: 15px;
  font-weight: 600;
}

.product-feature-item::before {
  content: '';
  flex-shrink: 0;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #2f6bff;
}

.product-price {
  margin-top: auto;
}

.product-price__row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.product-price__row + .product-price__row {
  margin-top: 18px;
}

.product-price__row span {
  color: #111;
  font-size: 17px;
  font-weight: 700;
}

.product-price__row strong {
  color: #111;
  font-size: 22px;
  font-weight: 800;
}

.pricing-contact {
  margin-bottom: 80px;
  padding: 40px 44px;
  border-radius: 32px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.10);
}

.pricing-contact__header {
  margin-bottom: 28px;
}

.pricing-contact__title {
  margin: 0 0 10px;
  color: #111;
  font-size: 30px;
  font-weight: 800;
  line-height: 1.3;
}

.pricing-contact__desc {
  margin: 0;
  color: #667085;
  font-size: 17px;
  line-height: 1.6;
}

.pricing-contact__box {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 18px 24px;
}

.pricing-contact__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 18px 20px;
  border-radius: 18px;
  background: #eef1f5;
}

.pricing-contact__label {
  color: #475467;
  font-size: 15px;
  font-weight: 700;
}

.pricing-contact__value {
  color: #111;
  font-size: 18px;
  font-weight: 800;
  text-align: right;
}

.pricing-contact__link {
  color: #2f6bff;
  font-size: 18px;
  font-weight: 800;
  text-decoration: none;
  word-break: break-all;
  cursor: default;
}

.pricing-contact__link:hover {
  text-decoration: underline;
}

.feature-fade-enter-active,
.feature-fade-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.feature-fade-enter-from,
.feature-fade-leave-to {
  opacity: 0;
  transform: translate(-50%, -46%);
}

@media (max-width: 1200px) {
  .pricing-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .pricing-contact__box {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .pricing-page {
    padding: 0 20px;
  }

  .pricing-section {
    padding: 28px 20px;
    border-radius: 24px;
  }

  .pricing-grid {
    grid-template-columns: 1fr;
  }

  .pricing-heading__title {
    font-size: 34px;
  }

  .product-card {
    min-height: 640px;
  }

  .product-title {
    font-size: 24px;
  }

  .product-feature-pop {
    width: 200px;
    padding: 20px 18px 26px;
  }

  .product-feature-chip {
    width: 100%;
    padding: 16px 18px;
    min-height: auto;
    border-radius: 20px;
    font-size: 15px;
  }

  .pricing-contact {
    padding: 28px 20px;
    border-radius: 24px;
    margin-bottom: 48px;
  }

  .pricing-contact__title {
    font-size: 24px;
  }

  .pricing-contact__item {
    flex-direction: column;
    align-items: flex-start;
  }

  .pricing-contact__value,
  .pricing-contact__link {
    text-align: left;
  }
}
</style>